/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Shot_status = "COMPLETED" | "FAILED" | "PENDING" | "PROCESSING" | "%future added value";
export type Shot_type = "enhanced" | "staged" | "%future added value";
export type Status = "CREATED" | "FAILED" | "PROCESSED" | "PROCESSING" | "%future added value";
export type TourShotsGrid_tour = {
    readonly id: string;
    readonly title: string;
    readonly status: {
        readonly status: Status;
    };
    readonly videoURL: string;
    readonly thumbnailURL: string;
    readonly shots: ReadonlyArray<{
        readonly id: string;
        readonly shotType: Shot_type;
        readonly shotStatus: Shot_status;
        readonly roomType: string;
        readonly frameScore: number;
        readonly sourceClipIndex: number;
        readonly sourceFramePosition: string;
        readonly originalImageURI: string;
        readonly enhancedImageURI: string;
        readonly stagedImageURI: string;
        readonly createdAt: unknown;
        readonly errorMessage: string;
    }>;
    readonly " $refType": "TourShotsGrid_tour";
};
export type TourShotsGrid_tour$data = TourShotsGrid_tour;
export type TourShotsGrid_tour$key = {
    readonly " $data"?: TourShotsGrid_tour$data;
    readonly " $fragmentRefs": FragmentRefs<"TourShotsGrid_tour">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TourShotsGrid_tour",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TourProgress",
      "kind": "LinkedField",
      "name": "status",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "videoURL",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thumbnailURL",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Shot",
      "kind": "LinkedField",
      "name": "shots",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "shotType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "shotStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "roomType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "frameScore",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sourceClipIndex",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sourceFramePosition",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "originalImageURI",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enhancedImageURI",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "stagedImageURI",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "errorMessage",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Tour",
  "abstractKey": null
};
})();
(node as any).hash = '369f566387313d2237c9e8375d2ac66d';
export default node;
